import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import {ClienteModel} from '../../models/vmi-clienteModel';

@Injectable({
  providedIn: 'root'
})
export class VmiClientesService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<ClienteModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.clientes);
  }

  getAllLoged(): Observable<ClienteModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.clientes+'/loged');
  }

  create(innObj: ClienteModel): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.clientes, innObj);
  }

  edit(innObj: ClienteModel): Observable<any> {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioUrl.clientes, innObj);
  }

  delete(innIdObj: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.clientes + `/${innIdObj}`);
  }
}
